/**
 * LoadingStageMessage — D-UI-STREAM-02 mapping locked (UI-SPEC líneas 226-237).
 *
 * Mapa estado → texto único cambiante (NO lista acumulativa, NO spinner mudo):
 *  classifying        → "Analizando consulta…"
 *  searching          → "Buscando en el catálogo…"
 *  thinking           → "Pensando…"
 *  middleware_block   → "Verificando seguridad" (warn chip)
 *  idle/complete/error/cancelled → null (no render)
 *
 * Acoplado al sseReducer del Plan 04-01.
 */
import { Icon } from './icons'
import { useChatStore } from '../store/chat'
import { TypingIndicator } from './TypingIndicator'

export function LoadingStageMessage() {
  const sseState = useChatStore((s) => s.sseState)

  if (
    sseState.status === 'idle' ||
    sseState.status === 'complete' ||
    sseState.status === 'error' ||
    sseState.status === 'cancelled'
  ) {
    return null
  }

  if (sseState.status === 'middleware_block') {
    return (
      <div
        role="alert"
        aria-live="assertive"
        className="inline-flex items-center gap-2 text-[13px] font-medium"
        style={{
          padding: '8px 12px',
          borderRadius: 'var(--radius-s)',
          background: 'var(--color-warn-soft)',
          color: 'var(--color-warn)',
          border: '1px solid var(--color-warn)',
        }}
      >
        <Icon.Alert width={14} height={14} aria-hidden="true" style={{ verticalAlign: '-2px', marginRight: 4 }} />
        Verificando seguridad
      </div>
    )
  }

  const text =
    sseState.status === 'classifying'
      ? 'Analizando consulta…'
      : sseState.status === 'searching'
        ? 'Buscando en el catálogo…'
        : 'Pensando…'

  return (
    <div
      role="status"
      aria-live="polite"
      className="inline-flex items-center gap-3"
      style={{
        padding: '10px 14px',
        borderRadius: 'var(--radius-l)',
        borderBottomLeftRadius: 6,
        background: 'var(--color-bubble-staff)',
        border: '1px solid var(--color-bubble-staff-border)',
      }}
    >
      <span
        className="text-[14px]"
        style={{ color: 'var(--color-text-muted)' }}
      >
        {text}
      </span>
      <TypingIndicator />
    </div>
  )
}
